<template>
    <div class="ph3 ph4-ns pb4">
        <div class="flex flex-wrap mv4">
            <a class="pointer"><img class="grow mr3 mb2" style="height:40px;" src="@/assets/img/payment/payment_visa.svg"/></a>
            <a class="pointer"><img class="grow mr3" style="height:40px;" src="@/assets/img/payment/payment_mastercard.svg"/></a>
            <a class="pointer"><img class="grow mr3" style="height:40px;" src="@/assets/img/payment/payment_amex.svg"/></a>
            <a class="pointer"><img class="grow mr3" style="height:40px;" src="@/assets/img/payment/payment_discover.svg"/></a>
            <a class="pointer"><img class="grow mr3" style="height:40px;" src="@/assets/img/payment/payment_paypal.svg"/></a>
        </div>

        <LabeledControl class="mb2" label="Name on Card">
            <Textbox/>
        </LabeledControl>

        <LabeledControl class="mb2" label="Card Number">
            <div class="th flex items-center ba b--light-gray">
            <Textbox class="bn"/>
            <img class="mr3" style="width:35px;" src="@/assets/img/payment/payment_visa.svg"/>
            </div>
        </LabeledControl>

        <div class="flex justify-between mb2">
            <div style="width:47%">
                <LabeledControl  label="Expiry Date">
                    <Textbox/>
                </LabeledControl>
            </div>
            <div style="width:47%" class="w-45">
                <LabeledControl label="Security Code">
                    <Textbox/>
                </LabeledControl>
            </div>
        </div>

        <LabeledControl class="mb2" label="ZIP / Postal Code">
            <Textbox/>
        </LabeledControl>

        <div>
            <div class="cf">
                <div class="formLabel fl">Notes to Lender</div>
                <span class="fr mid-gray legal"><b>Optional</b></span>
            </div>
            <textarea class="pa3 w-100 h4"></textarea>
        </div>

    </div>

</template>

<script>
import LabeledControl from '@/components/controls/LabeledControl.vue';
import Textbox from '@/components/controls/Textbox.vue';

export default {
    components: {
        LabeledControl,
        Textbox
    }
};
</script>
